




















































import {
  computed,
  defineComponent,
  PropType,
  ref,
  useRoute,
  useStore,
  watch,
} from '@nuxtjs/composition-api'
import { sectionCoreProps } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import { CardTitleDescriptionImage as ICardTitleDescriptionImage } from '@/contracts/Cards'
import CardTitleDescriptionImage from '@/components/Cards/CardTitleDescriptionImage.vue'
import BlockGridAdvantagesItem from '@/components/BlockGridAdvantagesItem.vue'

export default defineComponent({
  name: 'SectionCardsTitleDescriptionImage',
  components: {
    BlockGridAdvantagesItem,
    CardTitleDescriptionImage,
    SectionBasic,
  },
  mixins: [sectionCoreProps],
  props: {
    cols: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    cards: {
      type: Array as PropType<ICardTitleDescriptionImage[]>,
      default: () => [],
    },
    tabs: {
      type: Array as PropType<{ name: string; value: string }[]>,
      default: () => [],
    },
    sliderMode: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore()
    const isMobile = computed<boolean>(
      (): boolean => store.getters['mediaQuery/isMobileMq']
    )
    const agileOptions = computed(() => ({
      navButtons: false,
      infinite: false,
      dots: true,
      speed: 800,
      slidesToShow: 1,
    }))
    // реактивное свойство для выбранной вкладки
    const activeTab = ref('all')

    // вычисляемое свойство для фильтрации карточек
    const filteredCards = computed(() => {
      // Если выбрана вкладка "all", возвращаем все карточки
      if (activeTab.value === 'all') {
        return props.cards
      }
      // Иначе фильтруем по полю filterValue
      return props.cards.filter((card) => card.filterValue === activeTab.value)
    })

    const route = useRoute()

    watch(
      () => route.value.hash,
      (tabId) => {
        const foundTab = props.tabs.find((tab) => `#${tab.value}` === tabId)
        if (foundTab) {
          activeTab.value = foundTab.value
        }
      },
      { immediate: true }
    )

    return {
      isMobile,
      agileOptions,
      activeTab,
      filteredCards,
    }
  },
})
